import { render, staticRenderFns } from "./setLogon.vue?vue&type=template&id=6463208a&scoped=true"
import script from "./setLogon.vue?vue&type=script&lang=js"
export * from "./setLogon.vue?vue&type=script&lang=js"
import style0 from "./setLogon.vue?vue&type=style&index=0&id=6463208a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6463208a",
  null
  
)

export default component.exports